document.addEventListener("DOMContentLoaded", function () {
  const scrollBtn = document.getElementById("scrollToTopBtn");

  window.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
      scrollBtn.classList.add("show");
    } else {
      scrollBtn.classList.remove("show");
    }
  });

  scrollBtn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

// $(document).on('click', '.drawer__footer a.sign-in-btn', function() {
//     	localStorage.setItem('drawer', 'open')
//     })
//     $(document).on('click', '.popup-login-close,.drawer__close,#CartDrawer-Overlay', function() {
//     	localStorage.removeItem('drawer')
//     })
 
//     $(document).ready(function() {
//     	localStorage.setItem("customredect", window.location.href);
//     	if (localStorage.getItem('drawer') == 'open') {
//     		$('cart-drawer.drawer').addClass('active')
//     	}
//     })

  setTimeout(() => {
  const drawer = document.querySelector("#recharge-storefront-experiences__cart-drawer");

  if (drawer && drawer.shadowRoot) {
    const style = document.createElement("style");
    style.innerText = `
      div.text-xs.text-right.text-storefront-drawer-accent.font-semibold {
        max-width: 160px;
        width: 173px;
        margin-left: auto;
        white-space: normal;
      }
    `;
    drawer.shadowRoot.appendChild(style);
  }
}, 400);
const autoshipButtonn = document.querySelector('.custom-product-form__submit');
if (autoshipButtonn) {
  autoshipButtonn.addEventListener('click', () => {
    setTimeout(() => {
      const drawer = document.querySelector("#recharge-storefront-experiences__cart-drawer");

      if (drawer && drawer.shadowRoot) {
        const style = document.createElement("style");
        style.innerText = `
          div.text-xs.text-right.text-storefront-drawer-accent.font-semibold {
            max-width: 160px;
            margin-left: auto;
            width: 173px;
            white-space: normal;
          }
        `;
        drawer.shadowRoot.appendChild(style);
      }
    }, 200);
  });
}

if (window.location.pathname === '/collections') {
    	window.location.href = '/';
    }
if (window.location.pathname === '/products') {
    	window.location.href = '/';
}
const intervalIdData = setInterval(() => {
    const links = document.querySelectorAll('.app-block-content a');
    if (links.length > 0) {
      links.forEach(link => { 
        link.setAttribute('target', '_blank');
      });
      clearInterval(intervalIdData);
    }
  }, 500)


